import React from 'react'
import { Box, Container, useMediaQuery } from '@mui/material';
import { useTheme } from '@emotion/react';

const WrapperSection = ({ link, children }) => {
  const themeM = useTheme();
  const isMobile = useMediaQuery(themeM.breakpoints.down('sm')); 
  return (
    <>
      <div id={link} style={{ flex: 1, width:'100%' }}>
        <Container maxWidth={'lg'} sx={{px:1}} >
          <Box sx={{ my: { md: 5 ,xs:1}, display: 'flex', flexDirection: 'column', gap: { md: 1.7, xs: 1 }, alignItems: 'center', position: 'relative', zIndex: 11, textAlign: isMobile && 'center' }} >
            {children}
          </Box>
        </Container>
      </div>
    </>
  )
}

export default WrapperSection